import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { RoleEnum } from 'app/models/role.model';
import { User } from 'app/models/user.model';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoleMenuFormComponent } from '../role-menu-form/role-menu-form.component';


@Component({
    selector: 'role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class RoleListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _roleList: Array<RoleModel> = [];
    public user: User;

    public get roleList(): Array<RoleModel> {
        return this._roleList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<RoleModel> = undefined;
    public get dataSource(): MatTableDataSource<RoleModel> {
        return this._dataSource;
    }

    private _displayedColumns = ['index', 'name', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _dialog: MatDialog,
        private _spinner:NgxSpinnerService,
        private _toastService: ToasterService
    ) {
    }


    public async ngOnInit() {
        await this.getRoleList();
    }

    private async getRoleList(): Promise<Array<RoleModel>> {
        try {
            this._spinner.show('loading')
            let enumObjects = Object.entries(RoleEnum).map(([key, value]) => ({ name: key, id: value }));

            const roles = enumObjects.filter(
                element => typeof element.id === 'number'
            );

            roles.forEach(element => {
                const role = new RoleModel();
                role.id = element.id.toString();
                role.name = element.name;
                this._roleList.push(role);
            });
            this._spinner.hide('loading')

        } catch (error) {
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<RoleModel>(this._roleList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }


    public roleMenuClick(role) {
        const dialog = this._dialog.open(RoleMenuFormComponent, {
            width: '1000px'
        });
        dialog.componentInstance.role = cloneDeep(role);
        dialog.componentInstance.added.subscribe((model: boolean) => {
            dialog.close();
        })
    }

    refresh() {
        this.getRoleList();
    }



}


export class RoleModel {
    public id?: string
    public name?: string
}
